import {
  FIELD_TYPE_MULTI_LINE_TEXT,
  FIELD_TYPE_TEXT,
  FIELD_TYPE_BACKGROND_THEME_IMAGE,
  FIELD_TYPE_RECTANGLE,
  FIELD_TYPE_CIRCLE,
  FIELD_TYPE_SAFE_ZONE,
  FIELD_TYPE_PRODUCT_IMAGE,
  FIELD_TYPE_SMART_OBJECT
} from '@frontend/constants/type-fields-of-template';

import {
  DEFAULT_MULTI_LINE_TEXT_FIELD_PROPERTIES,
  DEFAULT_TEXT_FIELD_PROPERTIES,
  DEFAULT_RECTANGLE_FIELD_PROPERTIES,
  DEFAULT_CIRCLE_FIELD_PROPERTIES,
  DEFAULT_SAFE_ZONE_FIELD_PROPERTIES,
  DEFAULT_SMART_OBJECT_FIELD_PROPERTIES
} from '@frontend/group/modules/additional-fields';

export const FIELD_PREFIXES_MAP = {
  [FIELD_TYPE_MULTI_LINE_TEXT]: 'add_multi_line_text_',
  [FIELD_TYPE_TEXT]: 'add_text_',
  [FIELD_TYPE_BACKGROND_THEME_IMAGE]: 'add_bk_theme_img_',
  [FIELD_TYPE_RECTANGLE]: 'add_rectangle_',
  [FIELD_TYPE_CIRCLE]: 'add_circle_',
  [FIELD_TYPE_SAFE_ZONE]: 'add_safe_zone_',
  [FIELD_TYPE_PRODUCT_IMAGE]: 'add_bk_product_image_',
};

export const DEFAULT_PROPERTIES_MAP = {
  [FIELD_TYPE_MULTI_LINE_TEXT]: DEFAULT_MULTI_LINE_TEXT_FIELD_PROPERTIES,
  [FIELD_TYPE_TEXT]: DEFAULT_TEXT_FIELD_PROPERTIES,
  [FIELD_TYPE_BACKGROND_THEME_IMAGE]: DEFAULT_TEXT_FIELD_PROPERTIES,
  [FIELD_TYPE_RECTANGLE]: DEFAULT_RECTANGLE_FIELD_PROPERTIES,
  [FIELD_TYPE_CIRCLE]: DEFAULT_CIRCLE_FIELD_PROPERTIES,
  [FIELD_TYPE_SAFE_ZONE]: DEFAULT_SAFE_ZONE_FIELD_PROPERTIES,
  [FIELD_TYPE_SMART_OBJECT]: DEFAULT_SMART_OBJECT_FIELD_PROPERTIES,
};

export const LOADING_STATE_MAP = {
  [FIELD_TYPE_MULTI_LINE_TEXT]: {
    loading: 'Duplicating Text Layer...',
    toast: 'Multi Line Text Layer duplicated successfully'
  },
  [FIELD_TYPE_TEXT]: {
    loading: 'Duplicating Text Layer...',
    toast: 'Text Layer duplicated successfully'
  },
  [FIELD_TYPE_BACKGROND_THEME_IMAGE]: {
    loading: 'Duplicating Background Theme Image...',
    toast: 'Background Theme Image duplicated successfully'
  },
  [FIELD_TYPE_RECTANGLE]: {
    loading: 'Duplicating Rectangle...',
    toast: 'Rectangle duplicated successfully'
  },
  [FIELD_TYPE_CIRCLE]: {
    loading: 'Duplicating Circle...',
    toast: 'Circle duplicated successfully'
  },
  [FIELD_TYPE_SAFE_ZONE]: {
    loading: 'Duplicating Safe Zone...',
    toast: 'Safe Zone duplicated successfully'
  }
};
